module.exports = __webpack_public_path__ + "static/img/zhuapaijilu2.16965e5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/zhuapaijilu2.png
// module id = KFy4
// module chunks = 24